export class sendingRegistrationData{    

	companyName: string;
	firstName: string;
	lastName: string;
	gender: string;
	email: string;
	passWord: string;
	phone: string;
	altPhone: string;
	streetAddress: string;
	country: number;
	state: number;
	city: number;
	zipcode: string;
	timeZone: string;
	timeZoneOffset: string;
    totalLicences: number;
    
}